"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepsComparator = void 0;
require("../types");
const stepMapper = (step) => {
    const { body, form } = step, restProps = __rest(step, ["body", "form"]);
    return Object.assign(Object.assign({}, restProps), form);
};
const stepsComparator = (prevSteps, newSteps) => {
    var _a, _b;
    try {
        const left = (_a = prevSteps) === null || _a === void 0 ? void 0 : _a[0].map(stepMapper);
        const right = (_b = newSteps) === null || _b === void 0 ? void 0 : _b[0].map(stepMapper);
        if (!left || !right) {
            return left === right;
        }
        if (left.length !== right.length) {
            return false;
        }
        const keys = Object.keys(left);
        for (let i = length; i-- !== 0;) {
            if (!keys.every((key) => left[i][key] === right[i][key])) {
                return false;
            }
        }
        return true;
    }
    catch (e) {
        return false;
    }
};
exports.stepsComparator = stepsComparator;
//# sourceMappingURL=stepsComparator.js.map